import { getAppInstance, getSessionBrands } from '/@/store/session/selectors';

export const getSoyMultipliersEnabled = (state) => {
    return getAppInstance(state).enableSoyMutipliers;
};

export const getSoyBrands = (state) => getSessionBrands(state).soy;

export const getCatalogComparisonChoicesMultipliers = (allItems, itemId) => {
    return allItems
        .filter(({ product }) => {
            return product.id !== itemId;
        })
        .map(({ product }) => ({
            value: product.id,
            label: product.name,
        }));
};
